import Link from 'next/link';

import { ChainLinkVrf } from '@ui/uikit/components/icons/poly/ChainLinkVrf';

export const ChainLinkBanner = () => {
  return (
    <div className="inline-flex justify-center">
      <span className="bg-base-bg-secondary-blue text-caption-xs-a rounded-xl overflow-hidden px-2 py-1">
        <span className="text-caption-xs-a text-base-text-primary">
          <span className="whitespace-nowrap">Winners are chosen securely and</span>{' '}
          <span className="whitespace-nowrap">
            transparently through
            <ChainLinkVrf className="icon-xs mx-1" />
            <Link className="text-base-text-blue" href="https://chain.link/vrf" target="_blank">
              Chainlink VRF
            </Link>
          </span>
        </span>
      </span>
    </div>
  );
};
